/** Page sizes for the busy admin lists (products, orders): 10, 25 or 50 rows. */
export const LIST_PAGE_SIZE_OPTIONS = [10, 25, 50];

export const paginatorConfig = {
  initialPageSize: 10,
  pageSizeOptions: [5, 10, 25],
  showFirstLastButtons: true,
};
